import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateChannelRefreshTable } from "../../../redux/channels/channelSlice";
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";
// WIZARD COMPONENTS
import WizardExportButton from "../../setupWizard/components/WizardExportButton";
import WizardImportDialog from "../../setupWizard/components/WizardImportDialog";

function ChannelsHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [importOpen, setImportOpen] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { globalOrganizationId } = useSelector((state: RootState) => state.home);
  const [t] = useTranslation("global");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickReloadPage = () => {
    dispatch(updateChannelRefreshTable(true));
    setTimeout(() => {
      dispatch(updateChannelRefreshTable(false));
    }, 1000);
  };

  const handleImportSuccess = () => {
    onClickReloadPage();
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div className="generalStyles__pageHeader">
        {hasPermission(Permission.ChannelsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__8"
              icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
              onClick={() => {
                onClickReloadPage();
              }}
            >
              {t("userManagement.refreshTable")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.ChannelsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              icon={<UploadOutlined />}
              onClick={() => setImportOpen(true)}
              disabled={!globalOrganizationId}
            >
              Import
            </Button>
          </div>
        )}
        {hasPermission(Permission.ChannelsView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <WizardExportButton stage={3} orgId={globalOrganizationId || null} />
          </div>
        )}
      </div>
      {globalOrganizationId && (
        <WizardImportDialog
          orgId={globalOrganizationId}
          visible={importOpen}
          onClose={() => setImportOpen(false)}
          onSuccess={handleImportSuccess}
        />
      )}
    </div>
  );
}

export default ChannelsHeader;
